module.exports = __webpack_public_path__ + "website/img/successfulDetail_3_6.0b10ea48.png";